export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'view',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Anonymous',
      action: 'view',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Anonymous',
      action: 'view',
    },
  },
  {
    path: '/reset-password/:uid/:token',
    name: 'auth-reset-password',
    component: () => import('@/views/pages/authentication/ResetPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Anonymous',
      action: 'view',
    },
  },

  {
    path: '/pages/miscellaneous/coming-soon',
    name: 'misc-coming-soon',
    component: () => import('@/views/pages/miscellaneous/ComingSoon.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'view',
    },
  },
  {
    path: '/pages/miscellaneous/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'view',
    },
  },
  {
    path: '/pages/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
      resource: 'Anonymous',
      action: 'view',
    },
  },
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'view',
    },
  },
  {
    path: '/pages/profile',
    name: 'pages-profile',
    component: () => import('@/views/pages/profile/Profile.vue'),
    meta: {
      pageTitle: 'Profile',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Profile',
          active: true,
        },
      ],
      resource: 'Auth',
      action: 'view',
    },
  },
  {
    path: '/pages/manufacturers',
    name: 'pages-manufacturers',
    component: () => import('@/views/pages/manufacturers/Manufacturers.vue'),
    meta: {
      pageTitle: 'Manufacturers',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Manufacturers',
          active: true,
        },
      ],
      resource: 'Manufacturer',
      action: 'manage',
    },
  },
  {
    path: '/pages/brands',
    name: 'pages-brands',
    component: () => import('@/views/pages/brands/Brands.vue'),
    meta: {
      pageTitle: 'Brands',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Brands',
          active: true,
        },
      ],
      resource: 'Brand',
      action: 'manage',
    },
  },
  {
    path: '/pages/collections',
    name: 'pages-collections',
    component: () => import('@/views/pages/collections/Collections.vue'),
    meta: {
      pageTitle: 'Collections',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Collections',
          active: true,
        },
      ],
      resource: 'Collection',
      action: 'manage',
    },
  },
  {
    path: '/pages/settings',
    name: 'pages-settings',
    component: () => import('@/views/pages/settings/Settings.vue'),
    meta: {
      pageTitle: 'Account Settings',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Account Settings',
          active: true,
        },
      ],
      resource: 'Settings',
      action: 'manage',
    },
  },
  {
    path: '/pages/manufacturer-connections/:id',
    name: 'pages-manufacturer-connections',
    component: () => import('@/views/pages/settings/Settings.vue'),
    meta: {
      pageTitle: 'Account Settings',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Account Settings',
          active: true,
        },
      ],
      resource: 'Settings',
      action: 'manage',
    },
  },
  {
    path: '/pages/agents',
    name: 'pages-agents',
    component: () => import('@/views/pages/agents/Agents.vue'),
    meta: {
      pageTitle: 'Agents',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Agents',
          active: true,
        },
      ],
      resource: 'Agent',
      action: 'manage',
    },
  },
]
